import Main from "../../containers/Main";
import Header from "./Header";
import SideBar from "./Navbar";


const Nav = ({ children }) => {
  return (
    <>
      <div className={`flex flex-col flex-1 h-screen bg-white overflow-hidden`}>
        <div className={`flex h-full bg-gray-50  flex-1 overflow-x-hidden`}>
          <SideBar />
          <div className="flex flex-col flex-1  w-full">
            <Header />
            <Main>{children}</Main>
          </div>
        </div>
      </div>
    </>
  );
};

export default Nav;
